<template>
    <div class="detail_header_small clearfix" v-if="!isJf">
        <a href="/" class="app_icon"></a>
        <a href="/" class="logo"></a>
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" target="_blank" class="download_app news_index_listb"></a>
    </div>
</template>
<script>
    export default {
        name: "appFooter",
        data() {
            return {
                isJf: false,
            }
        },
        created() {
            let originName = location.origin
            if(originName.indexOf("jfinfo.com") > -1) {
                this.isJf = true;
            }
        },
        methods: {

        }
    }
</script>
<style>
    .detail_header_small {
        width: 100%;
        height: 50.5px;
        border-top: 1px solid #d3d3d3;
        background: #fff;
        position: fixed;
        z-index: 999;
        bottom: 0;
        display: flex;
        align-items: center;
        padding: 0 13px;
        box-sizing: border-box;
    }
    .detail_header_small a{
        display: block;
    }
/*    .detail_header_small img {
        max-width: 350px;
        height: 24px;
        float: left;
        margin: 12px 0 0 15px;
    }
    .detail_header_small div {
        float: right;
        margin: 10px 10px 0 0;
    }
    .detail_header_small div a {
        float: left;
        width: 55px;
        height: 30px;
        border: 1px solid #fe484a;
        border-radius: 15px;
        font: 15px/30px "微软雅黑";
        text-align: center;
    }*/
    .app_icon{
        background: url("https://cdncos.aigupiao.com/assets/wap/img/app_icon.png");
        width: 34px;
        height: 34px;
        background-size: 100%;
        margin-right: 7px;
    }
    .logo{
        background: url(https://cdncos.aigupiao.com/assets/wap/img/log62.png);
        width: 163px;
        height: 17px;
        background-size: 100%;
    }
    .detail_header_small .download_app {
        /*color: #fff;
        background: #fe484a;*/
        background: url("https://cdncos.aigupiao.com/assets/wap/img/download.png");
        width: 57px;
        height: 28px;
        background-size: 100%;
        position: absolute;
        right: 13px;
    }
    a {
        text-decoration: none;
        outline: none;
        border: none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }
</style>